import IconComponent from '../Icon/IconComponent.vue';
import IconLoyaltyProgram from '../Icon/IconLoyaltyProgram.vue';

export default {
  name: 'LoyaltyCard',
  components: {
    IconComponent,
    IconLoyaltyProgram
  },
  props: {
    isConnected: {
      type: [Boolean, String],
      default: false
    },
    loyaltyCardText : {
      type: String,
      default:'',
    },
    loyaltyCardTitle : {
      type: String,
      default:'',
    },
  }
};
